import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { SessionManager } from '../../common/helpers/session-manager';

@Component({
  selector: 'app-payment-completed-message',
  templateUrl: './payment-completed-message.component.html',
  styleUrls: ['./payment-completed-message.component.css']
})
export class PaymentCompletedMessageComponent implements OnInit {

  currentPromotionCode: string;
  constructor(private router: Router, private sessionManager: SessionManager) { }

  ngOnInit() {
    debugger;
    this.currentPromotionCode = this.sessionManager.getPromoCode();
  }

  redirectToEmbla() {
    window.location.href = environment.emblanoUrl;
  }

  print() {
    window.print();
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/payment-completed-message/payment-completed-message.component.ts